import React, { useEffect, useState } from 'react';
import { Button, Card, Col, DatePicker, Form, Input, InputNumber, Modal, notification, Row, Select } from 'antd';
import dayjs from 'dayjs';
import { authAxios } from '../../services/auth-axios';

export function TournamentModal({ tournament, onTournamentSave, operation, isOpen, onFinish, children }) {
  const [loading, setLoading] = useState(false);
  const [games, setGames] = useState([]);
  const [formats, setFormats] = useState([]);
  const [prizes, setPrizes] = useState([]);
  const [form] = Form.useForm();

  const settingsByOperation = {
    edit: {
      operation: authAxios().put,
      url: `/tournaments/${tournament?.id}`,
    },
    create: {
      operation: authAxios().post,
      url: '/tournaments',
    },
  };
  const setting = settingsByOperation[operation];

  const fetchData = async () => {
    setLoading(true);
    try {
      const [gamesRes, formatsRes, prizesRes] = await Promise.all([
        authAxios().get('/games', { params: { size: 1000 } }),
        authAxios().get('/formats', { params: { size: 1000 } }),
        authAxios().get('/prizestructures', { params: { size: 1000 } }),
      ]);

      setGames(gamesRes.data.content);
      setFormats(formatsRes.data.content);
      setPrizes(prizesRes.data.content);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
      notification.error({ message: 'Erro ao buscar jogos, formatos e premiações' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) fetchData();
  }, [isOpen]);

  const buildOptions = (list) => list.map((item) => ({ label: item.name, value: item.id }));

  const handleFinish = async (values) => {
    setLoading(true);
    try {
      await setting.operation(setting.url, {
        ...values,
        format: { id: values.format },
        game: { id: values.game },
        prizeStructure: values.prizeStructure ? { id: values.prizeStructure } : null,
        dateTime: values.dateTime?.toISOString(),
      });
      notification.success({ message: 'Torneio salvo com sucesso!' });
    } catch (error) {
      console.error('Erro ao salvar torneio:', error);
      notification.error({ message: 'Erro ao salvar torneio', description: error.response?.data?.message });
    } finally {
      setLoading(false);
      onFinish();
      onTournamentSave();
    }
  };

  return (
    <>
      {children}
      <Modal open={isOpen} onCancel={onFinish} footer={null} afterClose={form.resetFields}>
        <Card title="Salvar Torneio">
          <Form
            layout="vertical"
            form={form}
            id="tournamentForm"
            onFinish={handleFinish}
            initialValues={{
              ...tournament,
              format: tournament?.format?.id,
              game: tournament?.game?.id,
              prizeStructure: tournament?.prizeStructure?.id,
              dateTime: tournament?.dateTime ? dayjs(tournament.dateTime) : null,
            }}
          >
            <Form.Item name="name" label="Nome" required rules={[{ required: true, message: 'Campo obrigatório' }]}>
              <Input placeholder="Nome do torneio" />
            </Form.Item>

            <Form.Item name="description" label="Descrição">
              <Input.TextArea rows={3} placeholder="Descrição do torneio" />
            </Form.Item>

            <Form.Item name="entryFee" label="Taxa de inscrição">
              <InputNumber style={{ width: '100%' }} placeholder="Ex: 20.00" min={0} />
            </Form.Item>

            <Form.Item
              name="dateTime"
              label="Data e hora"
              rules={[{ required: true, message: 'Campo obrigatório' }]}
            >
              <DatePicker showTime style={{ width: '100%' }} />
            </Form.Item>

            <Form.Item name="appCode" label="Código do App/Eventlink">
              <Input placeholder="Código usado no app de torneios" />
            </Form.Item>

            <Form.Item name="game" label="Jogo" required rules={[{ required: true, message: 'Campo obrigatório' }]}>
              <Select options={buildOptions(games)} placeholder="Selecione o jogo" />
            </Form.Item>

            <Form.Item name="format" label="Formato" required rules={[{ required: true, message: 'Campo obrigatório' }]}>
              <Select options={buildOptions(formats)} placeholder="Selecione o formato" />
            </Form.Item>

            <Form.Item name="prizeStructure" label="Premiação">
              <Select options={buildOptions(prizes)} allowClear placeholder="Selecione a premiação (opcional)" />
            </Form.Item>

            <Form.Item>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <Button block type="primary" htmlType="submit" loading={loading}>
                    Salvar Torneio
                  </Button>
                </Col>
                <Col span={24}>
                  <Button block type="dashed" onClick={onFinish} disabled={loading}>
                    Fechar
                  </Button>
                </Col>
              </Row>
            </Form.Item>
          </Form>
        </Card>
      </Modal>
    </>
  );
}
